import React from 'react'
import {
Box,
Button,
Grid,
Select,
useLocation,
useCallback,
useState,
useEffect,
GetCookie,
toast,
Modal,
Switch,
} from '../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index'
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "../../Libraries/Post/Customization/index";
import {
  useGetSelectiveNewsMutation,
  useGetRSSNewsMutation,
  useUpdateScreenFooterOptionMutation,
  useUpdateScreenConfigsMutation,
  useGetScreenConfigsMutation,
  useAddFooterContentMutation,
  useGetFooterContentMutation,
  useUpdateFooterContentStatusMutation,
  useUpdateFooterContentMutation,
  useDeleteFooterContentMutation,
  useUpdateFooterConfigsMutation,
} from '../../Redux/service/AllEmpData';
import Marquee from "react-fast-marquee";
import {
    TextField, IconButton, Divider, FormLabel,Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIconbtn from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";
import { FileUploader } from "react-drag-drop-files";
import plusIcon from "../../Assets/svgs/primary-shape.svg";

export default function FooterContent({ currentScreen }) {
  const [footerRssLink, setFooterRssLink] = useState('');
  const [footerText, setFooterText] = useState('');
  const [showFooterSettings, setShowFooterSettings] = useState(false);
  const [openLiveView, setOpenLiveView] = useState(false);
  const [marqueeText, setMarqueeText] = useState([]);
  const [footerColors, setFooterColors] = useState({ bg_color: '#000000', text_color: '#ffffff' });
  const [footerContent, setFooterContent] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [newContent, setNewContent] = useState("");
  const [footerBgImage, setFooterBgImage] = useState(null);
  const fileTypes = ["JPG", "PNG", "JPEG"];

  const [getSelectiveNews] = useGetSelectiveNewsMutation();
  const [getRSSNews] = useGetRSSNewsMutation();
  const [updateScreenFooterOption] = useUpdateScreenFooterOptionMutation();
  const [getConfigsData] = useGetScreenConfigsMutation();
  const [addFooterContent] = useAddFooterContentMutation();
  const [getFooterContent] = useGetFooterContentMutation();
  const [updateFooterContentStatus] = useUpdateFooterContentStatusMutation();
  const [updateFooterContent] = useUpdateFooterContentMutation();
  const [deleteFooterContent] = useDeleteFooterContentMutation();
  const [updateFooterConfigs] = useUpdateFooterConfigsMutation();

  const [selectedFooterOption, setSelectedFooterOption] = useState(currentScreen?.footer_option || 'none');

  useEffect(() => {
    if (!currentScreen) return;

    setSelectedFooterOption(currentScreen.footer_option || 'none');

    if (currentScreen.footer_option === 'RSS') setFooterRssLink(currentScreen.footer_value);
    else if (currentScreen.footer_option === 'Text') setFooterText(currentScreen.footer_value);

    getScreenConfigsData();
    getFooterContentData();
  }, [currentScreen]);

  const getFooterContentData = async () => {
    if (!currentScreen) return;
    try {
      const formData = new FormData();
      formData.append('txt_customer_id', localStorage.getItem('txt_customer_id'));
      formData.append('security_token', await GetCookie('es_token'));
      formData.append('ser_screen_id', currentScreen.ser_screen_id);

      const res = await getFooterContent(formData).unwrap();
      if (res.connection === 'true' && res.status === 'true' && res.data) {
        setFooterContent(res);
    
      }
    } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
  };
  const getScreenConfigsData = async () => {
    if (!currentScreen) return;

    try {
      const formData = new FormData();

      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );

      formData.append(
        "security_token",
        await GetCookie("es_token")
      );

      formData.append(
        "ser_screen_id",
        currentScreen.ser_screen_id
      );

      const res = await getConfigsData(formData).unwrap();

      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.data?.footer
      ) {
        const config = res.data.footer;

        setFooterColors({
          bg_color: config.bg_color || "#000000",
          text_color: config.text_color || "#ffffff",
        });

        if (
          config.logo_configs &&
          config.logo_configs.status === true &&
          config.logo_configs.url &&
          config.logo_configs.url !== "N/A"
        ) {
          setFooterBgImage(config.logo_configs.url);
        } else {
          setFooterBgImage(null);
        }
      }

    } catch (error) {
      console.error(error);
      toast.error(error.status);
    }
  };
  const handleFooterStatus = async (e, index) => {
      try {
          const footerToUpdate = footerContent.data[index];
          const currentStatus = footerToUpdate.txt_status === "true";   
          const newStatus = !currentStatus;                            
  
          const payload = new FormData();
          payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
          payload.append("security_token", await GetCookie("es_token"));
          payload.append("ser_screen_id", currentScreen.ser_screen_id);
          payload.append("ser_footer_id", footerToUpdate.ser_footer_id);
          payload.append("footer_status", newStatus.toString());      
  
          const res = await updateFooterContentStatus(payload).unwrap();
  
          if (res.connection === "true" && res.status === "true") {
          toast.success(res.message);
          setFooterContent(prev => ({
              ...prev,
              data: prev.data.map((item, i) =>
              i === index
                  ? { ...item, txt_status: newStatus.toString() }
                  : item
              ),
          }));
          } else {
          toast.info(res.message);
          }
      } catch (error) {
          console.error(error);
          toast.error(error.status);
      }
      };

  const handleLiveView = async () => {
    if (!currentScreen) return;

    try {
      if (
        ["News", "Urdu News", "English News", "Cricinfo"].includes(
          selectedFooterOption
        )
      ) {
        const formData = new FormData();

        formData.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );

        formData.append(
          "security_token",
          await GetCookie("es_token")
        );

        formData.append("footer_key", selectedFooterOption);

        const res = await getSelectiveNews(formData).unwrap();

        if (
          res.status === "true" &&
          res.connection === "true"
        ) {
          setMarqueeText(res.data);
          setOpenLiveView(true);
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }

      } else if (selectedFooterOption === "RSS") {

        const formData = new FormData();
        formData.append("txt_rss_link", footerRssLink);

        const res = await getRSSNews(formData).unwrap();

        if (res.status === "true") {
          setMarqueeText(res.data);
          setOpenLiveView(true);
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }

      } else if (selectedFooterOption === "Text") {

          const activeFooterText =
            footerContent?.data?.filter(
              (item) => item.txt_status === "true"
            ) || [];

          setMarqueeText(activeFooterText);
          setOpenLiveView(true);
        }

    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };
  const handleUpdateScreenFooterOption = useCallback(async () => {
    if (!currentScreen) return;
    try {
      const formData = new FormData();
      formData.append('footer_option', selectedFooterOption);
      if (selectedFooterOption === 'RSS') formData.append('footer_value', footerRssLink);
      else if (selectedFooterOption === 'Text') formData.append('footer_value', footerText);
      else formData.append('footer_value', 'N/A');

      formData.append('txt_customer_id', localStorage.getItem('txt_customer_id'));
      formData.append('security_token', await GetCookie('es_token'));
      formData.append('ser_screen_id', currentScreen.ser_screen_id);

      const res = await updateScreenFooterOption(formData).unwrap();
      if (res.status === 'true') toast.success(res.message);
      else toast.info(res.message);
    } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
  }, [currentScreen, selectedFooterOption, footerRssLink, footerText]);
  const handleSaveFooterConfigs = async () => {
    if (!currentScreen) return;

    try {
      const formData = new FormData();

      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("ser_screen_id", currentScreen.ser_screen_id);

      formData.append(
        "configuration",
        JSON.stringify({ footer: footerColors })
      );

      if (footerBgImage) {
        formData.append("logo", footerBgImage);
      }

      const res = await updateFooterConfigs(formData).unwrap();

      if (res.connection === "true" && res.status === "true") {
        toast.success("Footer updated successfully!");
      } else {
        toast.error(res.message || "Failed to update footer");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.status);
    }
  };
  const handleAddFooterContent = async () => {
          try {
              const formData = new FormData();
              formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
              formData.append("security_token", await GetCookie("es_token"));
              formData.append("ser_screen_id", currentScreen.ser_screen_id);
              formData.append("txt_footer_content", newContent.title);
  
              let res;
              console.log(isEditMode);
              console.log("Testing");
  
              if (isEditMode) {
                  formData.append("ser_footer_id", editingId);
              } else {
                  // res = await addSidebarContent(formData).unwrap();
              }
  
              if (res.connection === "true" && res.status === "true") {
                  toast.success(res.message);
  
                  setAddModalOpen(false);
                  setNewContent("");
                  setIsEditMode(false);
                  setEditingId(null);
  
                  getFooterContentData();
              } else {
                  toast.error(res.message);
              }
  
          } catch (error) {
              console.error(error);
              toast.error(error.status);
              }
      };
  const handleEditFooter = (row) => {
      setIsEditMode(true);
      setEditingId(row.ser_footer_id);
      setNewContent(row.txt_footer_title);
      setAddModalOpen(true);
  };
  const handleFooterSubmission = async() => {
    try {
          if (!newContent) {
              toast.error("Please Add the Footer Value");
              return;
          }
          const formData = new FormData();
          formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
          formData.append("security_token", await GetCookie("es_token"));
          formData.append("ser_screen_id", currentScreen.ser_screen_id);
          formData.append("txt_footer", newContent);

          let res;

          if (isEditMode) {
              formData.append("ser_footer_id", editingId);
              res = await updateFooterContent(formData).unwrap();
          } else {
              res = await addFooterContent(formData).unwrap();
          }

          if (res.connection === "true" && res.status === "true") {
              toast.success(res.message);

              setAddModalOpen(false);
              setNewContent("");
              setIsEditMode(false);
              setEditingId(null);

              getFooterContentData();
          } else {
              toast.error(res.message);
          }

      } catch (error) {
          console.error(error);
          toast.error(error.status);
      }
  };
  const handleDeleteFooter = async(rowId) => {
        try {
            const formData = new FormData();
            formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            formData.append("security_token", await GetCookie("es_token"));
            formData.append("ser_screen_id", currentScreen.ser_screen_id);
            formData.append("ser_footer_id", rowId);
            let res;

            if (isEditMode) {
                formData.append("ser_footer_id", editingId);
                res = await deleteFooterContent(formData).unwrap();
            } else {
                res = await deleteFooterContent(formData).unwrap();
            }

            if (res.connection === "true" && res.status === "true") {
                toast.success(res.message);
                getFooterContentData();
            } else {
                toast.error(res.message);
            }

        } catch (error) {
            console.error(error);
            toast.error(error.status);
        }
    }
    const handleChangebgImg = (file) => {
      setFooterBgImage(file);
    };
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={0} className="flex flex-column  bg bg-white py-4 px-4" sx={{ borderRadius: '16px'}}>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", mb:2 }}>
            <h5 style={{ color: "grey" }}><b>Footer</b></h5>
            <div className="flex items-center gap-1">
              <span style={{ fontSize:"13px", color:"#666"}}>Settings</span>
              <Switch
                size="small"
                checked={showFooterSettings}
                onChange={(e) => setShowFooterSettings(e.target.checked)}
              />
            </div>
          </Box>

          <div className="justify-content-between no-gutters ml-1 mr-1">
            {/* <div className="py-2">
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={selectedFooterOption}
                  onChange={(e) => setSelectedFooterOption(e.target.value)}
                >
                  <FormControlLabel className="txt-color" value="Urdu News" control={<Radio />} label="Urdu News" />
                  <FormControlLabel className="txt-color"  value="English News" control={<Radio />} label="English News" />
                  <FormControlLabel className="txt-color"  hidden value="Cricinfo" control={<Radio />} label="Cricinfo" />
                  <FormControlLabel className="txt-color"  value="Text" control={<Radio />} label="Text" />
                  {selectedFooterOption === "none" ? null : (
                    <Button 
                        onClick={handleLiveView} 
                        className="capitalized fs-14 fw-bold underlined txt-color"
                      >
                        Live View
                      </Button>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      flexDirection:"column",
                      width: "20%",
                    }}
                  >
                    <Button
                      className="capitalized fs-14 fw-bold"
                      style={{
                        maxHeight: "48px",
                        height: "40px",
                        // width: "250px",
                        fontWeight: "bold",
                        textTransform: "none",
                        borderRadius: "8px",
                      }}
                      color="primary"
                      variant="contained"
                      onClick={handleUpdateScreenFooterOption}
                    >
                      Update Footer
                    </Button>
                  </Box>
                </RadioGroup>
              </FormControl>
            </div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                gap: "16px",
              }}
            >
              {/* LEFT SIDE */}
              <Box sx={{ flex: 1 }}>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    row
                    value={selectedFooterOption}
                    onChange={(e) => setSelectedFooterOption(e.target.value)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "nowrap",
                      gap: 1,
                    }}
                  >
                    <FormControlLabel
                      className="txt-color"
                      value="Urdu News"
                      control={<Radio />}
                      label="Urdu News"
                    />

                    <FormControlLabel
                      className="txt-color"
                      value="English News"
                      control={<Radio />}
                      label="English News"
                    />

                    <FormControlLabel
                      className="txt-color"
                      value="Text"
                      control={<Radio />}
                      label="Text"
                    />

                    {selectedFooterOption !== "none" && (
                      <Button
                        onClick={handleLiveView}
                        className="capitalized fs-14 fw-bold underlined txt-color"
                      >
                        Live View
                      </Button>
                    )}
                  </RadioGroup>
                </FormControl>
              </Box>

              {/* RIGHT SIDE BUTTON */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <Button
                  className="capitalized fs-14 fw-bold"
                  style={{
                    fontWeight: "bold",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    background:"1a75e8",
                    boxShadow:"none",
                  }}
                  color="primary"
                  variant="contained"
                  onClick={handleUpdateScreenFooterOption}
                >
                  Update Footer
                </Button>
              </Box>
            </div>

            <div className="col col-sm-6 col-md-6 col-lg-6 align-items-right w-100">
              {selectedFooterOption === "RSS" && (
                <div className="form-group col-md-6 mt-3">
                  <label>Footer RSS Link</label>
                  <textarea
                    value={footerRssLink}
                    onChange={(e) => setFooterRssLink(e.target.value)}
                    style={{ overflow:"hidden" }}
                  />
                </div>
              )}
          </div>
            </div>
              {selectedFooterOption === "Text" && (
                <div className="form-group ">
                  <table className="table align-middle bg-white" >
                    <thead className="bg-light fs-14" >
                        <tr>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "left",
                            textAlign: "left",
                            paddingLeft:"4%"
                            }}
                        >
                            Footer Text
                        </th>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "center",
                            textAlign: "center",
                            }}
                        >
                            Status
                        </th>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "center",
                            textAlign: "center",
                            }}
                        >
                            Action
                        </th>
                        </tr>
                    </thead>
                      <tbody>
                        {Array.isArray(footerContent?.data) && footerContent.data.length > 0 ? (
                          footerContent.data.map((row, index) => (
                            <tr key={row.ser_footer_id}>
                              <td
                                style={{
                                  width: "50%",
                                  alignItems: "left",
                                  textAlign: "left",
                                  paddingLeft: "4%",
                                }}
                              >
                                <h6
                                  className="mb-1"
                                  style={{ fontSize: "14px", letterSpacing: "0px" }}
                                >
                                  {row.txt_footer_title?.length > 30
                                    ? row.txt_footer_title.substring(0, 30) + "..."
                                    : row.txt_footer_title}
                                </h6>
                              </td>
                              <td
                                style={{
                                  width: "10%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Switch
                                  // checked={Boolean(row?.txt_status)}
                                  checked={row?.txt_status === "true"}
                                  inputProps={{ "aria-label": "controlled" }}
                                  onChange={(e) => handleFooterStatus(e, index)}
                                />
                              </td>

                              <td
                                style={{
                                  width: "30%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <IconButton
                                onClick={() => handleEditFooter(row)}
                                >
                                  <EditIcon sx={{ color: "#1976d2" }} />
                                </IconButton>

                                <IconButton
                                onClick={(e) => handleDeleteFooter(row.ser_footer_id)}
                                >
                                  <DeleteIconbtn sx={{ color: red[900] }} />
                                </IconButton>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4} className="text-center text-muted">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>

                            
                    </table>
                </div>
              )}
              <div className='flex justify-content-center gap-4 mb-2'>
              {selectedFooterOption === "Text" && (
                <Button
                  className="capitalized fw-bold"
                  variant="contained"
                  startIcon={
                    <img
                      src={plusIcon}
                      alt="plus"
                      className="plus-icon"
                      style={{
                        width: "18px",
                        height: "18px",
                        objectFit: "contain",
                        transition: "0.3s ease",
                      }}
                    />
                  }
                  onClick={() => setAddModalOpen(true)}
                  sx={{
                    maxHeight: "48px",
                    height: "40px",
                    width: "250px",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: "8px",
                    background: "#1A75E829",
                    boxShadow: "none",
                    color: "#1A75E8",
                    fontSize: "15px",
                    transition: "0.3s ease",

                    "&:hover": {
                      backgroundColor: "#1A75E8",
                      color: "#ffffff",
                      boxShadow: "none",
                    },

                    "&:hover .plus-icon": {
                      filter: "brightness(0) invert(1)",
                    },
                  }}
                >
                  Add New
                </Button>
              )}
              {/* <Button
                className="capitalized fs-14 fw-bold"
                style={{
                  maxHeight:"48px", 
                  height:"40px",
                  width:"250px" , 
                  fontWeight:"bold", 
                  textTransform:"none", 
                  borderRadius:"8px" 
                }}
                color="primary"
                variant="contained"
                onClick={handleUpdateScreenFooterOption}
              >
                Update Footer
              </Button> */}
              </div>

        </Grid>
      </Box>

       {showFooterSettings && (
          <Box sx={{ mt: 2 }}>
            <Grid
              container
              className="bg bg-white py-4 px-4"
              sx={{ borderRadius: "16px" }}
            >
              <Grid item xs={12}>
                <h6 style={{ fontWeight: 600, color: "#7e7e7e" }}>
                  Footer Configuration
                </h6>
              </Grid>

              {/* Background Color */}
              <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <input
                    type="color"
                    value={footerColors.bg_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        bg_color: e.target.value,
                      })
                    }
                    style={{
                        width: "25px",
                        height: "25px", 
                        border: 'none',
                        cursor: "pointer", 
                        padding: "0px", 
                        marginLeft: "2%",
                        background: "#ffffff",
                        boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                      }}
                  />
                  <TextField
                    label="Background Color"
                    size="small"
                    value={footerColors.bg_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        bg_color: e.target.value,
                      })
                    }
                    fullWidth
                    sx={{
                        fontSize: "14px",
                        // width: "100px",   
                        "& .MuiInputBase-root": {
                        height: "35px", 
                        fontSize: "14px",
                        },
                        "& .MuiInputLabel-root": {
                        fontSize: "12px",  
                        },
                    }}
                  />
                </Box>
              </Grid>

              {/* Text Color */}
              <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <input
                    type="color"
                    value={footerColors.text_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        text_color: e.target.value,
                      })
                    }
                      style={{
                        width: "25px",
                        height: "25px", 
                        border: 'none',
                        cursor: "pointer", 
                        padding: "0px", 
                        marginLeft: "2%",
                        background: "#ffffff",
                        boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                      }}
                  />
                  <TextField
                    label="Text Color"
                    size="small"
                    value={footerColors.text_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        text_color: e.target.value,
                      })
                    }
                    fullWidth
                    sx={{
                      fontSize: "14px",  
                      "& .MuiInputBase-root": {
                      height: "35px", 
                      fontSize: "14px",
                      },
                      "& .MuiInputLabel-root": {
                      fontSize: "12px",  
                      },
                  }}
                  />
                </Box>
              </Grid>
              {/* Upload Footer Icon Functionality */}
             {selectedFooterOption === "Text" && (
              <Grid item xs={12} sm={6} sx={{ mt: 3, ml: 1 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>

                  {/* Upload Footer Logo */}
                  {!footerBgImage ? (
                    <Box
                      sx={{
                        border: "1px dashed #c1c3c6",
                        borderRadius: "8px",
                        p: 1,
                        background: "#fff",
                      }}
                    >
                      <FileUploader
                        handleChange={handleChangebgImg}
                        name="file"
                        types={fileTypes}
                        multiple={false}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        position: "relative",
                        width: "120px",
                        height: "80px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        border: "1px solid #ddd",
                        padding:"5px"
                        // boxShadow: "0 0 8px rgb(193 195 198 / 70%)",
                      }}
                    >
                      {/* Preview Image */}
                      <img
                        src={
                          typeof footerBgImage === "string"
                            ? footerBgImage
                            : URL.createObjectURL(footerBgImage)
                        }
                        alt="preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />

                      {/* Remove Icon */}
                      <Box
                        onClick={() => setFooterBgImage(null)}
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          background: "rgba(0,0,0,0.7)",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ✕
                      </Box>
                    </Box>
                  )}
                </Box>
              </Grid>
            )}

              <Grid item xs={12} sx={{ mt: 3 , ml: 1 }}>
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    maxHeight: "48px",
                    height: "35px",
                    width: "150px",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: "8px",
                    background: "#1A75E8",
                    boxShadow: "none",
                    color: "#ffffff",
                    transition: "0.3s ease",
                    fontSize:"14px",

                    "&:hover": {
                      backgroundColor: "#1A75E829",
                      color: "#1A75E8",
                      boxShadow: "none",
                    },
                  }}
                  onClick={handleSaveFooterConfigs}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}

       {/* <Modal
          open={openLiveView}
          onClose={() => {
            setOpenLiveView(false);
          }}
          classNames={{
            overlayAnimationIn: "customEnterOverlayAnimation",
            overlayAnimationOut: "customLeaveOverlayAnimation",
            modalAnimationIn: "customEnterModalAnimation",
            modalAnimationOut: "customLeaveModalAnimation",
          }}
          animationDuration={800}
          styles={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
  
            modal: {
              width: "90%",
              height: "15%",
              padding: "unset",
              overflow: "hidden",
            },
            overlay: {
              background: "rgba(0, 0, 0, 0.5)",
            },
            closeButton: {
              background: "yellow",
            },
          }}
          center
        >
          <Marquee
            className="mt-6"
            speed={20}
            direction={
              currentScreen?.footer_option === "Urdu News" ? "right" : "left"
            }
          >
            {marqueeText.map((data) => {
              return <p>{data?.txt_news_title + "                      ."}</p>;
            })}
          </Marquee>
        </Modal> */}
        {/* ///New Modal View for Live Preview Footer Starts */}
       <Modal
        open={openLiveView}
        onClose={() => setOpenLiveView(false)}
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          modal: {
            width: "90%",
            height: "80px",
            padding: "0 20px",   
            overflow: "hidden",
            background: footerColors.bg_color,
            borderRadius: "8px",
            position: "relative", 
          },

          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },

         closeButton: {
          position: "absolute",
          top: "8px",
          right: "10px",
          zIndex: 10,
          fill: footerColors.text_color, 
          fontSize: "18px",
          fontWeight: "bold",
          border: "none",
          cursor: "pointer",
        },
        }}
        center
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            background: footerColors.bg_color,
            overflow: "hidden",
          }}
        >

          {/* Marquee Section */}
          <Box
            sx={{
              flex: 1,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Marquee
            speed={20}
            gradient={false}
            direction={selectedFooterOption === "Urdu News" ? "right" : "left"}
          >
            {marqueeText?.map((data, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mr: 3,
                  gap: 1,
                }}
              >
                {/* Text */}
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: 600,
                    color: footerColors.text_color,
                    whiteSpace: "nowrap",
                  }}
                >
                  {data?.txt_footer || data?.txt_footer_title || data?.txt_news_title}
                </span>

                {/* Logo after every text */}
                {footerBgImage && (
                  <img
                    src={
                      typeof footerBgImage === "string"
                        ? footerBgImage
                        : URL.createObjectURL(footerBgImage)
                    }
                    alt="logo"
                    style={{
                      width: "35px",
                      height: "35px",
                      objectFit: "contain",
                    }}
                  />
                )}
              </Box>
            ))}
          </Marquee>
          </Box>
        </Box>
      </Modal>
        {/* ///New Modal View for Live Preview Footer End */}
         <Dialog open={addModalOpen} onClose={() => setAddModalOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle style={{paddingTop: "5%", paddingBottom: '0%'}}>
              <h5 style={{fontWeight: 600, color:'#7e7e7e'}}>
                  {isEditMode ? "Edit Sidebar Content" : "Add New Footer Text"}
              </h5>
          </DialogTitle>

          <DialogContent>

              <TextField
                  label="Enter Footer note here"
                  fullWidth
                  margin="normal"
                  value={newContent || ""}
                  rows={4}
                  multiline
                  onChange={(e) => setNewContent(e.target.value)}
              />
          </DialogContent>
          <DialogActions style={{padding: "5%"}}>
              <Button onClick={() => {
                  setAddModalOpen(false);
                  setIsEditMode(false);
                  setEditingId(null);
                  setNewContent("");
              }}>
                  Cancel
              </Button>
              <Button variant="contained" 
              onClick={handleFooterSubmission}
              >
                  Submit
              </Button>
          </DialogActions>
        </Dialog>

    </>
  );
}

